// extracted by mini-css-extract-plugin
export default {"image":"qX-z","loaded":"rX-z"};